module.exports = __webpack_public_path__ + "img/jpBusinessCooperation.8d4b4cc.png";